import { defaultCurrencyFormat } from './currency-format';
import { defaultNumberConfig } from './number';
/**
 * The default currency configuration.
 * Example: $123,456.78
 */
export const defaultCurrencyConfig = Object.assign(Object.assign({}, defaultNumberConfig), { symbol: '$', format: defaultCurrencyFormat });
//# sourceMappingURL=currency.js.map